import { useEffect, useState } from 'react'
import { useCookies } from 'react-cookie'

import { regionCookieName, Regions, SG } from '@/modules/configs/region'

import { getRegion, getTraceObject, traceUser } from './utils'

export const useUserRegion = () => {
  const [userRegion, setUserRegion] = useState<Regions>('GLOBAL')
  const [cookies] = useCookies([regionCookieName])

  useEffect(() => {
    const regionCookie = cookies[regionCookieName]
    const getUsersRegion = async () => {
      try {
        const { data } = await traceUser()
        const { loc: location } = getTraceObject(data)
        const region = getRegion(location)
        if (region === SG) {
          setUserRegion(region)
        } else if (regionCookie) {
          setUserRegion(regionCookie)
        } else {
          setUserRegion(region)
        }
      } catch (error) {
        //TODO can just do nothing for now
        console.error(error)
      }
    }

    getUsersRegion()
  }, [cookies])

  return userRegion
}

export const getUsersRegion = async () => {
  try {
    const { data } = await traceUser()
    const { loc: location } = getTraceObject(data)
    const region = getRegion(location)
    return region
  } catch (error) {
    //TODO can just do nothing for now
    console.error(error)
  }
}
